import BusinessInvoicesContext from 'app/Components/Page/BusinessInvoicesPage/BusinessInvoicesContext';
import React, {memo, useContext} from 'react';
import Select from './Select';
import classNames from 'classnames';

const BusinessInvoicesSelect = () => {
  const [{list, collapsed, selected}, dispatch] = useContext(BusinessInvoicesContext);

  return list ? (
    <div className={classNames('BusinessInvoicesSelect', {collapsed, selected: selected?.netvInd || selected?.cellInd})}>
      <div className='BusinessInvoicesSelect__input'>
        <Select
          selected={selected}
          items={list.bussinessOrgList}
          placeholder='בחירת ח.פ.'
          onSelect={(item) => dispatch({type: 'select', item})}
          render={(item) => (
            <div className='orgOption'>
              <span className='idNumber'>{item.idNumber}</span>
              <span className='orgName'>{item.orgName}</span>
            </div>
          )}
        />
      </div>
    </div>
  ) : null;
};

export default memo(BusinessInvoicesSelect);
